import { cn } from "@/lib/utils"
import { TButton } from "@/components/ui/atoms"
import { Card, TCardProps } from "@/components/ui/molecules"
import { CardListContainer } from "@/components/ui/organisms"

type TCardListProps = {
  title?: string
  titleCenter?: boolean
  className?: string
  smallInfo?: string
  isInArticle?: boolean
  list: TCardProps[]
  buttons?: TButton[]
  variant?: "article" | "component"
  backgroundDark?: boolean
}

const CardList = ({
  title,
  titleCenter,
  smallInfo,
  list,
  backgroundDark,
  isInArticle = false,
  className,
  buttons,
  variant = "component",
}: TCardListProps) => {
  return (
    <CardListContainer
      title={title}
      titleCenter={titleCenter}
      smallInfo={smallInfo}
      className={cn(
        className,
        backgroundDark ? "bg-secondary-500" : "",
        variant === "article" ? "" : "py-10 lg:py-14"
      )}
      variant={variant}
      centered={list.length <= 2}
      buttons={buttons}
    >
      {list.map((card) => {
        return (
          <Card
            className={cn(
              list.length <= 2
                ? "md:mb-unset mb-6 min-w-full px-4 md:w-6/12 md:min-w-0 xl:w-4/12"
                : "",
              "lg:col-span-2"
            )}
            isInArticle={isInArticle}
            key={card.title}
            title={card.title}
            imagePosition={card.imagePosition}
            body={card.body}
            src={card.src ? card.src + "?h=760&w=1160&fm=webp&q=80" : undefined}
            alt={card.alt}
            variant={card.variant}
            clamp={card.clamp}
          />
        )
      })}
    </CardListContainer>
  )
}

export { CardList, type TCardListProps }
